/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type EventBar_event$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type EventCommonPart_event$ref: FragmentReference;
declare export opaque type EventCommonPart_event$fragmentType: EventCommonPart_event$ref;
export type EventCommonPart_event = {|
  +sgId: ?number,
  +$fragmentRefs: EventBar_event$ref,
  +$refType: EventCommonPart_event$ref,
|};
export type EventCommonPart_event$data = EventCommonPart_event;
export type EventCommonPart_event$key = {
  +$data?: EventCommonPart_event$data,
  +$fragmentRefs: EventCommonPart_event$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "EventCommonPart_event",
  "type": "Event",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sgId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "EventBar_event",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '73daa5789119dcd2a40bc9d03486557f';

module.exports = node;
